import React, { useState } from 'react';
import { IMPACT_COLORS, RISK_STATUS_LABELS } from '../../utils/constants';
import { updateRiskStatus } from '../../api/risks';

const RISK_STATUS_OPTIONS = ['abierto', 'mitigado', 'aceptado', 'cerrado'];

function RiskRow({ risk, onUpdated, onRiskClick, showToast }) {
  const [updating, setUpdating] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(risk.status);
  const impactColor = IMPACT_COLORS[risk.impact] || 'var(--danger)';

  async function handleStatusChange(e) {
    e.stopPropagation();
    const newStatus = e.target.value;
    const prevStatus = currentStatus;
    setCurrentStatus(newStatus);
    setUpdating(true);
    try {
      await updateRiskStatus(risk.id, newStatus);
      onUpdated?.();
      showToast?.('Estado actualizado', 'success');
    } catch {
      setCurrentStatus(prevStatus);
      showToast?.('Error al actualizar', 'error');
    } finally {
      setUpdating(false);
    }
  }

  return (
    <div
      className={`list-row${risk.entry?.id ? ' clickable' : ''}`}
      onClick={() => risk.entry?.id && onRiskClick?.(risk)}
    >
      <span className="priority-dot" style={{ background: impactColor, flexShrink: 0 }} />
      <div className="list-row__main">
        <span className="list-row__title">
          {risk.description?.slice(0, 90)}{risk.description?.length > 90 ? '…' : ''}
        </span>
        <div className="list-row__meta">
          <span className="meta-chip" style={{ color: impactColor }}>{risk.impact}</span>
          {risk.probability && <span className="meta-chip">{risk.probability}</span>}
          {risk.task?.title && (
            <span className="meta-chip">→ {risk.task.title?.slice(0, 35)}</span>
          )}
          {risk.entry?.id && <span className="meta-chip" style={{ color: 'var(--accent)', opacity: 0.8 }}>📨</span>}
        </div>
      </div>
      <select
        className="filter-select filter-select--inline"
        value={currentStatus}
        onChange={handleStatusChange}
        disabled={updating}
        onClick={e => e.stopPropagation()}
      >
        {RISK_STATUS_OPTIONS.map(s => (
          <option key={s} value={s}>{RISK_STATUS_LABELS[s]}</option>
        ))}
      </select>
    </div>
  );
}

export default RiskRow;
